import { render } from "./DecorationSetEditModal.vue?vue&type=template&id=6639d42a&scoped=true"
import script from "./DecorationSetEditModal.vue?vue&type=script&lang=js"
export * from "./DecorationSetEditModal.vue?vue&type=script&lang=js"

import "./DecorationSetEditModal.vue?vue&type=style&index=0&id=6639d42a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6639d42a"]])

export default __exports__